













import Vue from 'vue';
import Auth from '@/shared/auth';

interface Methods {
  logout: () => Promise<void>;
}

export default Vue.extend<{}, Methods, {}, {}>({
  name: 'app',
  methods: {
    async logout () {
      await Auth.logout();
      window.setTimeout(() => window.location.reload(), 1000);
    }
  }
});
